import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b9668d66"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-xxl mb-16" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-sm-12 col-md-12 col-lg-6 col-xl-4" }
const _hoisted_4 = { class: "col-sm-12 col-md-12 col-lg-6 col-xl-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppBreadcrumb = _resolveComponent("AppBreadcrumb")!
  const _component_DesignerHeadline = _resolveComponent("DesignerHeadline")!
  const _component_DesignerInformation = _resolveComponent("DesignerInformation")!
  const _component_DesignerCover = _resolveComponent("DesignerCover")!
  const _component_DesignerShowcase = _resolveComponent("DesignerShowcase")!
  const _component_DesignerBanner = _resolveComponent("DesignerBanner")!
  const _component_GetStartedBanner = _resolveComponent("GetStartedBanner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AppBreadcrumb, { "breadcrumb-items": _ctx.breadcrumbItems }, null, 8, ["breadcrumb-items"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_DesignerHeadline, { designer: _ctx.designer }, null, 8, ["designer"]),
          _createVNode(_component_DesignerInformation)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_DesignerCover, { designer: _ctx.designer }, null, 8, ["designer"]),
          _createVNode(_component_DesignerShowcase, { designer: _ctx.designer }, null, 8, ["designer"])
        ])
      ])
    ]),
    _createVNode(_component_DesignerBanner),
    _createVNode(_component_GetStartedBanner)
  ], 64))
}